export const LicenseAssignationModalStyles = {
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxWidth: "calc(100% - 20px)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  },
  searchField: {
    mb: 2,
  },
  noResultsText: {
    mt: 2,
  },
  button: {
    textTransform: "none",
  },
  userList: {
    width: "100%",
    bgcolor: "background.paper",
    maxHeight: 400,
    overflow: "auto",
  },
  confirmationPanel: {
    mt: 3,
    p: 2,
  },
  confirmationText: {
    mb: 2,
  },
} as const;
